import { createCriteriaParameters, standardDeleteQuery, standardGetQuery, standardPostQuery, standardPutQuery } from "./apiUtils.js";
import { replacePlaceholdersWithObjValues, setDeleteArrayState, setInsertArrayState } from "../shared/miscUtils.js";

import * as Constants from "../../config/constants/Constants.js";
import { SNACKBAR_SUCCESS_CREATED, SNACKBAR_SUCCESS_DELETED, SNACKBAR_SUCCESS_UPDATED } from "../../config/language/english.js";

/**
 * Function for creating a new cookie.
 * In use for resource add stepper form.
 */
export const createCookieStepper = (props, options = {}, callback = null) => {
    const path = Constants.API_COOKIES;

    standardPostQuery(props, path, options.body, (response) => {
        if (callback) callback(response.body);
    });
};

/**
 * Function for querying an existing cookie.
 */
export const queryCookieStepper = (props, options = {}, callback = null) => {
    const path = Constants.API_COOKIES_LATEST + "?type=" + options.type;

    standardGetQuery(
        props,
        path,
        (response) => {
            if (callback) callback(response.body);
        },
        { showMessage: false }
    );
};

/**
 * Function for querying cookies with filters, pagination, sorting etc.
 */
export const queryCookies = (props, options = {}) => {
    const path = Constants.API_COOKIES + createCriteriaParameters(options);

    standardGetQuery(props, path, (response) => {
        const states = props.backend.cookies;

        setInsertArrayState(states.setData, response.body.elements);
        states.setQueryLoading(false);

        if (options.pagination === false) return;

        if (options.page !== undefined) states.setQueriedUntil(options.page);
        if (response?.body?.total !== undefined) states.setRowCount(response.body.total);
    });
};

/**
 * Function for creating a new cookie.
 */
export const createCookie = (props, options = {}, callback = null) => {
    const path = Constants.API_COOKIES;

    standardPostQuery(props, path, options.body, (response) => {
        const states = props.backend.cookies;

        setInsertArrayState(states.setData, [{ ...response.body }]);
        states.setRowCount((prev) => prev + 1);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_CREATED });
        if (callback) callback(response.body);
    });
};

/**
 * Function for updating a cookie.
 */
export const updateCookie = (props, options = {}, callback = null) => {
    const path = replacePlaceholdersWithObjValues(Constants.API_COOKIES_ID, { cookie_id: options.id });

    standardPutQuery(props, path, options.body, (response) => {
        const states = props.backend.cookies;

        setInsertArrayState(states.setData, [{ ...response.body }]);

        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_UPDATED });
        if (callback) callback(response.body);
    });
};

/**
 * Function for deleting cookie(s).
 */
export const deleteCookies = (props, options = {}) => {
    const path = Constants.API_COOKIES;

    standardDeleteQuery(props, path, options.body, (response) => {
        const states = props.backend.cookies;

        setDeleteArrayState(states.setData, options.ids);

        states.setRowCount(states.rowCount - options.ids.length);
        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_DELETED });
    });
};
